module.exports = __webpack_public_path__ + "media/src/assets/Images/lock-01-cece35036d61f6a003646aa230402361.svg";